__turbopack_context__.v({
  "eds-example-grid-coloring": "HomeBottomShelfContainer-module-scss-module__KHv4cW__eds-example-grid-coloring",
  "eds-example-grid-content": "HomeBottomShelfContainer-module-scss-module__KHv4cW__eds-example-grid-content",
  "eds-example-sidebar-content": "HomeBottomShelfContainer-module-scss-module__KHv4cW__eds-example-sidebar-content",
  "eds-g-cell": "HomeBottomShelfContainer-module-scss-module__KHv4cW__eds-g-cell",
  "eds-g-sidebar": "HomeBottomShelfContainer-module-scss-module__KHv4cW__eds-g-sidebar",
  "eds-g-view": "HomeBottomShelfContainer-module-scss-module__KHv4cW__eds-g-view",
  "root": "HomeBottomShelfContainer-module-scss-module__KHv4cW__root",
  "wrapper": "HomeBottomShelfContainer-module-scss-module__KHv4cW__wrapper",
});
